import React, { useContext, useEffect, useState } from 'react'
import { CButton, CFormSelect, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import 'src/views/container/cms/content.scss'
import '../../../scss/style.scss'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import InfiniteScroll from 'react-infinite-scroll-component'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { GlobalContext } from 'src/views/context/GlobalState'
import { isEmpty } from 'lodash'
import { getThumbnail } from 'src/views/utils/helper'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { ARTIST_LISTING } from 'src/views/utils/urls'
import Loading from 'react-fullscreen-loading'
import CustomPreviewListCard from 'src/views/container/AssetManager/customPreviewListCard'

const DefaultArtistSwimlaneModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  const { setLoader, loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [reverse, setReverse] = useState(false)
  const [orderBy, setOrderBy] = useState('modified_date')
  const [title, setTitle] = useState('')
  const [page, setPage] = useState(1)
  const [artistData, setArtistData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [{ data: artistList, loading: artistLoading }, artistListCall] = useAxios(
    {
      url: ARTIST_LISTING,
      method: 'get',
    },
    {
      manual: true,
    },
  )

  useEffect(() => {
    setTitle(componentData?.data?.name)

    setOrderBy(componentData?.data?.order_by)
    setReverse(componentData?.data?.reverse)
  }, [])

  useEffect(() => {
    setLoader(artistLoading)
  }, [artistLoading])

  useEffect(() => {
    setPage(1)
    artistListCall({
      params: {
        page: 1,
        order_by: orderBy === 'title' ? `title.${language}` : orderBy,
        reverse: reverse,
        page_size: PAGE_SIZE,
      },
    })
  }, [orderBy, reverse])

  useEffect(() => {
    if (artistList && artistList.success) {
      page === 1
        ? setArtistData(artistList.data)
        : setArtistData((artistData) => [...artistData, ...artistList.data])
    }
  }, [artistList])

  const handleNextPage = () => {
    artistListCall({
      params: {
        page: page + 1,
        order_by: orderBy === 'title' ? `title.${language}` : orderBy,
        reverse: reverse,
        page_size: PAGE_SIZE,
      },
    })
    setPage((page) => page + 1)
  }

  const handleSave = () => {
    let elementObj = {
      name: title,
      order_by: orderBy,
      reverse: reverse,
    }
    modifyData(componentData.id, elementObj)
  }

  const handleOrderBy = (value) => {
    let valueArr = value.split('-')
    setOrderBy(valueArr[0])
    setReverse(valueArr[1] === 'desc')
  }
  return (
    <CModal size="xl" className="swimlane-content-modal" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />

      <CModalHeader style={{}} className="d-flex flex-column align-items-start mt-1 px-5">
        <div className="d-flex justify-content-center w-100">
          <p style={{ fontSize: '1.2rem' }} className="">
            <b style={{ fontWeight: '500', color: '#191818' }}>Artist Swimlane Editor</b>
          </p>
        </div>
        <div className="w-100 d-flex justify-content-between">
          <div className="w-50 mt-2">
            <h6 style={{ fontSize: '13px', color: '#191919' }} className="">
              HEADING
            </h6>
            <CustomDescriptionBox
              limit={100}
              rows={1}
              value={title}
              onChange={(value) => setTitle(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="w-25 mt-2">
            <h6 style={{ fontSize: '13px', color: '#191919' }} className="">
              Order By
            </h6>
            <CFormSelect
              value={`${orderBy}-${!reverse ? 'aesc' : 'desc'}`}
              onChange={(e) => {
                handleOrderBy(e.target.value)
              }}
            >
              <option value={'modified_date-desc'}>Modified Date Descending</option>
              <option value={'modified_date-aesc'}>Modified Date Ascending</option>
              <option value={'created_date-desc'}>Created Date Descending</option>
              <option value={'created_date-aesc'}>Created Date Ascending</option>
              <option value={'title-aesc'}>Title {`(A to Z)`}</option>
              <option value={'title-desc'}>Title {`(Z to A)`}</option>
              <option value={'random-aesc'}>Random</option>
            </CFormSelect>
          </div>
        </div>
      </CModalHeader>
      <CModalBody className="  d-flex flex-column justify-content-between px-5 ">
        <div style={{ marginTop: '5px' }}>
          <div className="position-relative overflow-hidden">
            <div
              className="custom-scrollbar-vertical"
              style={{
                height: '53vh',
                overflowY: 'auto',
                padding: '30px 2px 10px 2px',
                overflowX: 'hidden',
              }}
            >
              <div
                className="d-flex justify-content-center align-items-center w-100 bg-black text-white position-absolute rounded-2"
                style={{
                  fontSize: 'max(0.63vw,10px)',
                  gap: '0 .6%',
                  padding: '2px .5vw',
                  zIndex: '10',
                  position: 'fixed',
                  top: '0',
                }}
              >
                <div style={{ width: '2%', height: '100%' }}></div>
                <div style={{ width: '9%', height: '100%' }}></div>
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ width: '85%', background: 'none' }}
                >
                  <p style={{ marginBlockEnd: '0', width: '25%', background: 'none' }}>Name</p>
                  <p style={{ marginBlockEnd: '0', width: '25%', background: 'none' }}>Type</p>
                  <p style={{ marginBlockEnd: '0', width: '50%', background: 'none' }}>Bio</p>
                  <div style={{ width: '2%' }}></div>
                </div>
              </div>
              <InfiniteScroll
                dataLength={artistData.length} //This is important field to render the next data
                next={handleNextPage}
                hasMore={artistList && artistList.total > page * 20}
                style={{ overflowX: 'hidden' }}
                loader={<p>Loading...</p>}
                className="scrollbar-class"
                height={`48vh`}
                scrollableTarget="scrollableDiv"
              >
                <ul className="list-unstyled pr-2">
                  {!isEmpty(artistData) ? (
                    artistData.map((info, index) => (
                      <li key={index}>
                        <CustomPreviewListCard
                          disableHoverEffect={true}
                          cardStyle={{ marginBottom: '.84vw', aspectRatio: '1181/71' }}
                          cardImage={getThumbnail(
                            userSessionObj.session_data.cf_domain_name,
                            info?.thumbnail,
                          )}
                          playIconForVideo={false}
                          fileName={info?.name}
                          rightText={<span className="line-clamp-2">{info?.bio}</span>}
                          duration={info?.artist_type}
                          contentType={''}
                          categories={[]} // categories
                          actionButtonAction={null}
                          fileNameWidth={'25%'}
                          durationWidth={'25%'}
                          rightTextWidth={'50%'}
                          contentTypeWidth={'0%'}
                          categoriesWidth={'0%'}
                        />
                      </li>
                    ))
                  ) : (
                    <h5 className="no-data-text">No Content Found!</h5>
                  )}
                </ul>
              </InfiniteScroll>
            </div>
            <p style={{ marginBlockEnd: '0', fontSize: 'max(0.73vw,10px)', color: '#000' }}>
              * The items displayed are NOT Static.
            </p>
          </div>
        </div>
      </CModalBody>
      <CModalFooter style={{ border: 'none' }} className=" px-5">
        <CButton
          className=""
          style={{
            color: '#3a3838',
            backgroundColor: 'white',
            marginRight: '2rem',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          onClick={onCancel}
        >
          Cancel
        </CButton>
        <CButton
          color="info"
          className="text-white"
          style={{
            color: 'white',
            backgroundColor: '#20211c',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          onClick={handleSave}
        >
          {'Save'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default DefaultArtistSwimlaneModal
